import React from 'react';
import { COLORS, FilterField, SelectInput, PrimaryButton, SecondaryButton, MONTH_OPTIONS, currentYearOptions } from './InventoryUIKit';

/**
 * InvoiceFilters
 *
 * Generic filter bar shared by MonthlyInvoice / CampInvoice / BagInvoice.
 * Always renders Month + Year selects, plus any extra fields passed in
 * (e.g. Camp select, Bag select, Technician select), followed by an
 * actions area (Refresh / Generate buttons).
 *
 * @param {number} month
 * @param {number} year
 * @param {(v:number)=>void} onMonthChange
 * @param {(v:number)=>void} onYearChange
 * @param {React.ReactNode} [extraFields] - additional <FilterField> elements rendered before Month/Year
 * @param {() => void} onGenerate
 * @param {() => void} onRefresh
 * @param {boolean} [loading]
 */
const InvoiceFilters = ({
  month,
  year,
  onMonthChange,
  onYearChange,
  extraFields = null,
  onGenerate,
  onRefresh,
  loading = false,
}) => {
  return (
    <div
      style={{
        backgroundColor: COLORS.white,
        border: `1px solid ${COLORS.mediumGrey}`,
        borderRadius: '8px',
        padding: '16px 20px',
        marginBottom: '20px',
        display: 'flex',
        gap: '16px',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
      }}
    >
      {extraFields}

      <FilterField label="Month" minWidth="140px">
        <SelectInput value={month} onChange={(e) => onMonthChange(Number(e.target.value))}>
          {MONTH_OPTIONS.map((m) => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </SelectInput>
      </FilterField>

      <FilterField label="Year" minWidth="110px">
        <SelectInput value={year} onChange={(e) => onYearChange(Number(e.target.value))}>
          {currentYearOptions(6).map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </SelectInput>
      </FilterField>

      <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto' }}>
        {onRefresh && (
          <SecondaryButton onClick={onRefresh} disabled={loading}>↻ Refresh</SecondaryButton>
        )}
        {onGenerate && (
          <PrimaryButton onClick={onGenerate} disabled={loading}>
            {loading ? 'Generating…' : '📄 Generate'}
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};

export default InvoiceFilters;
